// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FactoryStock: React.FC = () => {
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="26"
            viewBox="0 0 30 26"
        >
            <defs>
                <polygon id="a" points="0 16 13 16 13 0 0 0" />
            </defs>
            <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                <path
                    fill="#BFD5DB"
                    stroke="#00205B"
                    d="M28.5,-0.5 L28.5,16.2071068 L20.2071068,24.5 L-0.5,24.5 L-0.5,7.79289322 L7.79289322,-0.5 L28.5,-0.5 Z"
                />
                <g transform="translate(8 4)">
                    <path
                        fill="#00205B"
                        d="M6.7626,10.2511 C6.6756,7.8861 6.5546,5.5141 6.4056,4.9791 C6.5886,4.9131 6.7206,4.7421 6.7206,4.5361 C6.7206,4.2731 6.5086,4.0611 6.2456,4.0611 L4.4936,4.0611 C4.2316,4.0611 4.0186,4.2731 4.0186,4.5361 C4.0186,4.7421 4.1506,4.9131 4.3336,4.9791 C4.1846,5.5141 4.0636,7.8861 3.9766,10.2511 L6.7626,10.2511 Z"
                    />
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        fill="#00205B"
                        d="M11.308 11.526 12.422 11.526 12.422 10.412 11.308 10.412 11.308 11.526ZM11.308 13.197 12.422 13.197 12.422 12.083 11.308 12.083 11.308 13.197ZM9.541 11.526 10.655 11.526 10.655 10.412 9.541 10.412 9.541 11.526ZM9.541 13.197 10.655 13.197 10.655 12.083 9.541 12.083 9.541 13.197ZM7.557 10.669 1.828 10.669 1.828 16 3.192 16 3.192 13.335 6.601 13.335 6.601 16 13 16 13 10.669 13 7.023 7.557 10.669ZM4.6111 2.8321C4.6111 2.8361 4.6091 2.8391 4.6091 2.8421 4.6091 3.2501 4.9401 3.5811 5.3481 3.5811 5.7031 3.5811 5.9851 3.3261 6.0561 2.9921 6.2421 3.0711 6.4471 3.1141 6.6621 3.1141 7.0341 3.1141 7.3701 2.9791 7.6381 2.7621 7.8411 2.9131 8.0901 3.0061 8.3621 3.0061 9.0351 3.0061 9.5801 2.4601 9.5801 1.7881 9.5801 1.1151 9.0351.5701 8.3621.5701 8.2081.5701 8.0621.6021 7.9261.6541 7.6441.2591 7.1841.0001 6.6621.0001 6.0831.0001 5.5841.3191 5.3151.7881 5.1521.6931 4.9641.6341 4.7611.6341 4.1501.6341 3.6551 1.1301 3.6551 1.7411 3.6551 2.3001 4.0721 2.7581 4.6111 2.8321"
                        mask="url(#b)"
                    />
                    <path
                        fill="#00205B"
                        d="M2.8908,4.1661 C3.1008,4.1171 3.2608,3.9371 3.2608,3.7121 C3.2608,3.4491 3.0478,3.2371 2.7858,3.2371 L0.6668,3.2371 C0.4048,3.2371 0.1918,3.4491 0.1918,3.7121 C0.1918,3.9391 0.3538,4.1201 0.5668,4.1671 C0.2138,5.4721 -0.0002,16.0001 -0.0002,16.0001 L1.3918,16.0001 L1.3918,10.2511 L3.2958,10.2511 C3.1978,7.5511 3.0608,4.7931 2.8908,4.1661"
                        mask="url(#b)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(FactoryStock);
